import React from 'react';
import Chip from '@material-ui/core/Chip';
import * as lib from '~/dependencies';
import { truncate } from '~/helpers';

import { Label, Container } from './styles';

export default function Interaction({ data }: any) {
  const { type, date, status, body } = data;
  return (
    <Container>
      <Label className="customize-clip">
        {type} <Chip label={status} color="primary" size="small" />
      </Label>
      <span className="date-time">
        {lib.dayjs(date).format('DD/MM/YYYY HH:mm:ss')}
      </span>

      <span className="email-body">
        <Label>Message:</Label>{' '}
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: lib.sanitizeHtml(truncate(body, 150)),
          }}
        />
      </span>
    </Container>
  );
}
